<template>
	<div class="banner-top color-blue">
		<div class="container">
			<div class="callbacks_container">
				<el-carousel indicator-position="none">
					<el-carousel-item class="banner_text">
						<h3>商标注册</h3>
						<p>Trademark registration</p>
						<div class="w3-button">
							<a href="#" data-toggle="modal" data-target="#myModal">Read More</a>
						</div>
					</el-carousel-item>
					<el-carousel-item class="banner_text">
						<h3>版权登记</h3>
						<p>Copyright registration</p>
						<div class="w3-button">
							<a href="#" data-toggle="modal" data-target="#myModal">Read More</a>
						</div>
					</el-carousel-item>
					<el-carousel-item class="banner_text">
						<h3>软件著作权申请</h3>
						<p>Software copyright application</p>
						<div class="w3-button">
							<a href="#" data-toggle="modal" data-target="#myModal">Read More</a>
						</div>
					</el-carousel-item>
					<el-carousel-item class="banner_text">
						<h3>专利</h3>
						<p>Patent application</p>
						<div class="w3-button">
							<a href="#" data-toggle="modal" data-target="#myModal">Read More</a>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Banner'
	}
</script>

<style>
	.callbacks_container {
		margin-top: 10rem;
	}

	.callbacks_container .el-carousel {
		overflow: hidden;
	}
</style>
